import * as R from 'ramda';
import { all, select, fork, cancel, race, call, put, take, takeEvery, takeLatest, cancelled } from 'redux-saga/effects';
import entityActions from '../../genericActions/entityActions';
import db from '../../db/db';

const getAllSaga = function* (connectionId) {
  try {
    let tabs;
    yield call(db.transaction.bind(db), 'rw', [db.tabs, db.queries, db.categories], async () => {
      tabs = await db.tabs.where('connectionId').equals(connectionId).toArray();
      const categories = R.indexBy(R.prop('tabId'), await db.categories.toArray());
      const queries = R.indexBy(R.prop('tabId'), await db.queries.toArray());
      tabs = tabs.map(tab => ({
        ...tab,
        category: categories[tab.id],
        query: queries[tab.id],
      }));
    });

    yield put(entityActions.receiveEntities(
      `/connection/${connectionId}`,
      {
        type: 'tabs',
        byId: R.indexBy(R.prop('id'), tabs),
        ids: R.pluck('id')(tabs),
      },
    ));

    return tabs;
  } catch (e) {
    console.error(e);
  }
};

const openSaga = function* (connectionId, type, entityId) {
  try {
    let tab;
    yield call(db.transaction.bind(db), 'rw', [db.tabs, db.queries, db.categories], async () => {
      const tabId = await db.tabs.add({ connectionId, opened: Date.now() });

      if (type === 'category') {
        await db.categories.add({ tabId, sourceId: entityId || null });

        tab = await db.tabs.where('id')
          .equals(tabId)
          .first()
        ;

        tab.category = await db.categories.where('tabId').equals(tab.id).first();
      } else if (type === 'query') {
        await db.queries.add({ tabId, name: '', vbql: '' });

        tab = await db.tabs.where('id')
          .equals(tabId)
          .first()
        ;

        tab.query = await db.queries.where('tabId').equals(tab.id).first();
      }
    });

    const tabIds = yield select(store => R.pathOr([], ['tab', `/connection/${connectionId}`, 'ids'], store));
    yield put(entityActions.receiveEntities(
      `/connection/${connectionId}`,
      {
        type: 'tabs',
        byId: { [tab.id]: tab },
        ids: R.uniq([...tabIds, tab.id]),
      },
    ));

    return tab;
  } catch (e) {
    console.error(e);
  }
};

const updateCategorySaga = function* (connectionId, tabId, serverId) {
  try {
    let tab;
    yield call(db.transaction.bind(db), 'rw', [db.tabs, db.queries, db.categories], async () => {
      await db.categories.where('tabId').equals(tabId).modify({ sourceId: serverId });

      tab = await db.tabs.where('id')
        .equals(tabId)
        .first()
      ;

      tab.category = await db.categories.where('tabId').equals(tab.id).first();
    });

    const tabIds = yield select(store => R.pathOr([], ['tab', `/connection/${connectionId}`, 'ids'], store));
    yield put(entityActions.receiveEntities(
      `/connection/${connectionId}`,
      {
        type: 'tabs',
        byId: { [tab.id]: tab },
        ids: R.uniq([...tabIds, tab.id]),
      },
    ));

    return tab;
  } catch (e) {
    console.error(e);
  }
};

const updateQuerySaga = function* (connectionId, tabId, query) {
  try {
    let tab;
    yield call(db.transaction.bind(db), 'rw', [db.tabs, db.queries, db.categories], async () => {
      await db.queries.where('tabId').equals(tabId).modify({ name: query.name, vbql: query.vbql });

      tab = await db.tabs.where('id')
        .equals(tabId)
        .first()
      ;

      tab.query = await db.queries.where('tabId').equals(tabId).first();
    });

    const tabIds = yield select(store => R.pathOr([], ['tab', `/connection/${connectionId}`, 'ids'], store));
    yield put(entityActions.receiveEntities(
      `/connection/${connectionId}`,
      {
        type: 'tabs',
        byId: { [tabId]: tab },
        ids: R.uniq([...tabIds, tabId]),
      },
    ));

    return tab;
  } catch (e) {
    console.error(e);
  }
};

const closeSaga = function* (connectionId, tabId) {
  try {
    yield call(db.transaction.bind(db), 'rw', [db.tabs, db.queries, db.categories], async () => {
      await db.queries.where('tabId').equals(parseInt(tabId, 10)).delete();
      await db.categories.where('tabId').equals(parseInt(tabId, 10)).delete();
      await db.tabs.delete(parseInt(tabId, 10));
    });

    const tabIds = yield select(store => R.pathOr([], ['tab', `/connection/${connectionId}`, 'ids'], store));
    yield put(entityActions.receiveEntities(
      `/connection/${connectionId}`,
      {
        type: 'tabs',
        byId: {},
        ids: R.difference(tabIds, [parseInt(tabId, 10)]),
      },
    ));
  } catch (e) {
    console.error(e);
  }
};

export default {
  closeSaga,
  openSaga,
  getAllSaga,
  updateCategorySaga,
  updateQuerySaga,
};
